
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
export interface ContactFormrops extends BaseComponentProps {
    lang: string;
    from: string;
}
export interface ContactFormState extends BaseComponentState {
    userLogin: any;
}
export class ContactForm extends BaseComponent<ContactFormrops, ContactFormState> {
    constructor(props: ContactFormrops) {
        super(props);
        this.state = {
            userLogin: {}
        };
    }  
    render() { 
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        return (
            <form id="contactForm">
                    <div className="row">
                        <div className="form-group">
                            <div className="col-md-6">
                                <label> Your name <span className="symbol required" /> </label>
                                <input type="text" value="" data-msg-required="Please enter your name." className="form-control" name="name" id="name" />
                            </div>
                            <div className="col-md-6">
                                <label> Your email address <span className="symbol required" /> </label>
                                <input type="email" value="" data-msg-required="Please enter your email address." data-msg-email="Please enter a valid email address." className="form-control" name="email" id="email" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <div className="col-md-12">
                                <label> Subject </label>
                                <input type="text" value="" data-msg-required="Please enter the subject." className="form-control" name="subject" id="subject" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <div className="col-md-12">
                                <label> Message <span className="symbol required" /> </label>
                                <textarea data-msg-required="Please enter your message." className="form-control" name="message" id="message" />
                                <input type="hidden" value={this.props.from}  id="from_url" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button data-caption-delay="900" data-caption-class="fadeIn" className="btn btn-primary margin-top-15 opacity-0 btn-wide btn-scroll btn-scroll-top fa-arrow-right animated fadeIn" type="button">
                                <span>Send Message</span>
                            </button>
                        </div>
                    </div>
                </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ContactForm.tsx